<div class="language-switcher">
  <select [formControl]="formControl" class="form-control">
    <option value="default" disabled selected>{{'language.select' | translate}}</option>
    @for (language of languages; track language) {
      <option [value]="language">
        {{ findLang(language)?.local }}
      </option>
    }
  </select>
</div>
